import { render } from "./Upgrading.vue?vue&type=template&id=3c53ba19"
import script from "./Upgrading.vue?vue&type=script&lang=js"
export * from "./Upgrading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__